import { AgmCoreModule } from '@agm/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggle,
  MatSlideToggleModule,
  MatTabsModule,
  MatTooltipModule,
  MatChipsModule,
  MatAutocompleteModule,
} from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { Md2DatepickerModule, MD_DATE_FORMATS } from 'md2';
import { NgDragDropModule } from 'ng-drag-drop';
import { ColorPickerModule } from 'ngx-color-picker';
import { ImageCropperModule } from 'ngx-img-cropper/index';
import { AccountUsersModalComponent } from '../components/admin/accounts/account.users/account.users.modal.component';
import { EventSpiderModalComponent } from '../components/admin/accounts/event.spider/event.spider.modal.component';
import { SetContactsModalComponent } from '../components/admin/accounts/set.contacts/set.contacts.modal.component';
import {
  SetPlaceSourceModalComponent
} from '../components/admin/accounts/set.place.source/set.place.source.modal.component';
import {
  ToggleFeaturesModalComponent
} from '../components/admin/accounts/toggle.features/toggle.features.modal.component';
import {
  AddSpiderEvenetsModalComponent
} from '../components/admin/add.spider.events.modal/add.spider.events.modal.component';
import {
  ToggleIsClientModalComponent
} from '../components/admin/accounts/toggle.is.client/toggle.is.client.modal.component';
import { AddCityModalComponent } from '../components/hub/add.city.modal/add.city.modal.component';
import {
  EditPlaceImagesModalComponent
} from '../components/hub/edit.place.images.modal/edit.place.images.modal.component';
import {
  GooglePlaceReviewsComponent
} from '../components/hub/google.place/google.place.reviews/google.place.reviews.component';
import { ShowInfoModalComponent } from '../components/hub/show.info.modal/show.info.modal.component';
import { UpgradeModalComponent } from '../components/hub/upgrade.modal/upgrade.modal.component';
import { EventDetailsModalComponent } from '../components/visitor/event.details.modal/event.details.modal.component';
import {
  PlaceMapSectionComponent
} from '../components/visitor/place.details.modal/place.map.section.component/place.map.section.component';
import { SocialShareComponent } from '../components/visitor/social.share/social.share.component';
import { TripDetailModalComponent } from '../components/visitor/trip/trip.detail.modal/trip.detail.modal.component';
import { ButtonComponent, MatFieldComponent } from './components';
import { AccordionComponent } from './components/accordion/accordion.component';
import { AddressInputComponent } from './components/address.input/address.input.component';
import { AltButtonComponent } from './components/alt.button/alt.button.component';
import { CitySelectorComponent } from './components/city.selector/city.selector.component';
import { CreateTripModalComponent } from './components/create.trip.modal/create.trip.modal.component';
import { DateFieldComponent } from './components/date.time.field/date.field.component';
import { DateTimeInputComponent } from './components/datetime.input/datetime.input.component';
import { DropDownComponent } from './components/drop.down/drop.down.component';
import { DropDownItemGroupComponent } from './components/drop.down/item.group/drop.down.item.group.component';
import { DropDownItemComponent } from './components/drop.down/item/drop.down.item.component';
import { DropDownTriggerComponent } from './components/drop.down/trigger/drop.down.trigger.component';
import { EditEventModalComponent } from '../components/hub/edit.event.modal/edit.event.modal.component';
import { EditPlaceModalComponent } from '../components/hub/edit.place.modal/edit.place.modal.component';
import {
  EditTourTitleModalComponent
} from '../components/hub/tours/edit.tour.title.modal/edit.tour.title.modal.component';
import {
  CommonErrorHandlerModalComponent
} from './components/error.modal/common.error.handler.modal/common.error.handler.modal.component';
import { ErrorHandlerModalComponent } from './components/error.modal/error.handler.modal.component';
import { ExportPdfModalComponent } from '../components/hub/export.pdf.modal/export.pdf.modal.component';
import { FacebookLoginButtonComponent } from './components/facebook.login.button/facebook.login.button.component';
import { FacebookPostComponent } from './components/facebook.post/facebook.post.component';
import { FieldComponent } from './components/field/field.component';
import { GoogleLoginButtonComponent } from './components/google.login.button/google.login.button.component';
import { ColumnComponent } from './components/grid/column/column.component';
import { RowComponent } from './components/grid/row/row.component';
import { ImageCropperWithPreviewComponent } from './components/image.cropper/image.cropper.component';
import { ImageViewerComponent } from './components/image.viewer/image.viewer.component';
import { LinkButtonComponent } from './components/link.button/link.button.component';
import { ListColumnHeaderComponent } from './components/list/column.header/list.column.header.component';
import { ListItemComponent } from './components/list/item/list.item.component';
import { ListComponent } from './components/list/list.component';
import { MultipleFieldsComponent } from './components/multiple.fields/multiple.fields.component';
import { NoContentComponent } from './components/no.content.tip/no.content.component';
import { PageSpinnerComponent } from './components/page.spinner/page.spinner.component';
import { PoweredByComponent } from './components/powered.by/powered.by.component';
import { ActionsComponent } from './components/row.action.buttons/actions/actions.component';
import { RowActionButtonsComponent } from './components/row.action.buttons/row.action.buttons.component';
import { SearchComponent } from './components/search/search.component';
import { ShareTripModalComponent } from '../components/visitor/trip/share.trip.modal/share.trip.modal.component';
import { SelectComponent } from './components/select/select.component';
import {
  ShowMoreEventTimesModalComponent
} from './components/show.more.event.times.modal/show.more.event.times.modal.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { StarsComponent } from './components/stars/stars.component';
import { SuccessWrapComponent } from './components/success.wrap/success.wrap.component';
import { UnsavedWarningModalComponent } from './components/unsaved.warning.modal/unsaved.warning.modal.component';
import { CardActionComponent } from './components/water.fall.container/card/action/card.action.component';
import { CardComponent } from './components/water.fall.container/card/card.component';
import { WaterFallContainerComponent } from './components/water.fall.container/water.fall.container.component';
import { OnlyFloatInputDirective, OnlyIntegerInputDirective, VisibilityHiddenDirective } from './directives';
import { DebounceEventDirective } from './directives/debounce/debounce-event.directive';
import { EmptyRouterLinkDirective } from './directives/empty.router.link/empty.router.link.directive';
import { UnsavedChangesGuard } from './guards';
import { ModalService } from './services/modal.service';
import { ConfirmModalComponent } from './components/confirm.modal/confirm.modal.component';
import {
  MobileIFrameExportPdfAlertModal
} from 'common/components/mobile.iframe.export.pdf.alert.modal/mobile.iframe.export.pdf.alert.modal';
import { SideFloatComponent } from 'common/components/side.float/side.float.component';
import { EditCityModalComponent } from 'components/hub/edit.city.modal/edit.city.modal.component';
import { AssignTourModalComponent } from 'components/hub/assign.tour.modal/assign.tour.modal.component';
import { ImageComponent } from 'common/components/image/image.component';
import { SocialLoginPopupComponent } from 'common/components/social.login.popup/social.login.popup.component';
import { PlaceDetailsModalComponent } from 'components/visitor/place.details.modal/place.details.modal.component';
import {
  VisitorPlaceOpeningHoursComponent
} from '../components/visitor/place.opening.hours/place.opening.hours.component';
import {
  PullGooglePlaceTypeModalComponent
} from '../components/hub/pull.google.place.type.modal/pull.google.place.type.modal.component';
import {
  NearbyPlacesComponent
} from 'components/visitor/place.details.modal/nearby.places.component/nearby.places.component';
import { VisitorLongCardComponent } from '../components/visitor/calendar/long.card/visitor.long.card.component';
import {
  SearchGooglePlaceResultModalComponent
} from 'components/hub/edit.account/content.management/search.google.place/search.google.place.result.modal/search.google.place.result.modal.component';
import { InputModalComponent } from './components/input.modal/input.modal.component';
import { ImageSelectorComponent } from './components/image.selector/image.selector.component';
import {
  VisitorTripAddToTripMenuComponent
} from '../components/visitor/trip/add.to.trip.menu/visitor.trip.add.to.trip.menu.component';
import {
  ShowPlacesCountModalComponent
} from 'components/admin/accounts/show.places.count/show.places.count.modal.component';
import { EventCountModalComponent } from 'components/admin/accounts/event.count/event.count.modal.component';
import { EventSubscriptionTiersModalComponent } from 'components/admin/accounts/event.subscription.tiers/event.subscription.tiers.modal.component';
import { ResizeImageModalComponent } from 'components/hub/resize.image.modal/resize.image.modal.component';
import { ImageResizeComponent } from './components/image.rezise/image.resize.component';
import {
  VisitorModernBlockCardComponent
} from '../components/visitor/calendar/modern.block.card/visitor.modern.block.card.component';
import { VisitorSquareCardComponent } from '../components/visitor/calendar/square.card/visitor.square.card.component';
import { UpcomingEventsComponent } from 'components/visitor/upcoming.events/upcoming.events.component';
import { NestedMenusComponent } from './components/nested.menu/nested.menu.component';
import { NestedMenuItemComponent } from './components/nested.menu/nested.menu.item/nested.menu.item.component';
import {
  EditPlaceCategoryModalComponent
} from 'components/hub/edit.place.category.modal/edit.place.category.modal.component';
import {
  PlaceCategorySelectorComponent
} from '../components/hub/edit.place.category.modal/place.category.selector/place.category.selector.component';
import { EventFilterComponent } from '../components/visitor/event.filter/event.filter.component';
import { SetIgVersionModalComponent } from '../components/admin/accounts/set.ig.version/set.ig.version.modal.component';
import {
  CustomDefaultPlaceCategoryAccordionComponent
} from '../components/hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
import { AccordionEditorComponent } from '../components/hub/accordion.editor/accordion.editor.component';
import { ShowImageModalComponent } from '../components/hub/show.image.modal/show.image.modal.component';
import {
  SetEventPageTagModalComponent
} from '../components/admin/accounts/event.spider/set.eventpage.tag.modal/set.eventpage.tag.modal.component';
import {
  BulkAIDescriptionsModalComponent
} from '../components/hub/bulk.ai.descriptions.modal/bulk.ai.descriptions.modal.component';
import {
  AIEventClassificationModalComponent
} from '../components/hub/ai.event.classification.modal/ai.event.classification.modal.component';
import {
  TravelBuddySettingsModalComponent
} from '../components/admin/accounts/travel.buddy.settings/travel.buddy.settings.modal.component';
import {
  TravelBuddyConversationsModalComponent
} from '../components/admin/accounts/travel.buddy.conversations/travel.buddy.conversations.modal.component';
import {
  ShowCategoryLinkModalComponent
} from '../components/hub/show.category.link.modal/show.category.link.modal.component';
import { ShowPromptModalComponent } from '../components/hub/show.prompt.modal/show.prompt.modal.component';
import {
  EventPullingStatusModalComponent
} from '../components/admin/accounts/event.pulling.status/event.pulling.status.modal.component';
import { EditManuallyPlaceImagesModalComponent } from '../components/hub/edit.manually.place.images.modal/edit.manually.place.images.modal.component';
import { AddEventbriteEvenetsModalComponent } from '../components/admin/add.eventbrite.events.modal/add.eventbrite.events.modal.component';
import { ClickStopPropagationDirective } from './directives/click.stop.propagation/click.stop.propagation.directive';
import { HighlightPipe } from '../pip/highlight.pipe';

let COMMON_COMPONENTS = [
  RowComponent,
  ColumnComponent,
  ButtonComponent,
  LinkButtonComponent,
  FieldComponent,
  MatFieldComponent,
  DateFieldComponent,
  DateTimeInputComponent,
  CitySelectorComponent,
  DropDownComponent,
  DropDownItemComponent,
  DropDownItemGroupComponent,
  DropDownTriggerComponent,
  AccordionComponent,
  StarsComponent,
  PoweredByComponent,
  WaterFallContainerComponent,
  AddressInputComponent,
  AltButtonComponent,
  ConfirmModalComponent,
  InputModalComponent,
  UnsavedWarningModalComponent,
  ExportPdfModalComponent,
  EditEventModalComponent,
  AIEventClassificationModalComponent,
  ResizeImageModalComponent,
  UpgradeModalComponent,
  EditPlaceModalComponent,
  EditPlaceImagesModalComponent,
  EditManuallyPlaceImagesModalComponent,
  EditPlaceCategoryModalComponent,
  PlaceCategorySelectorComponent,
  BulkAIDescriptionsModalComponent,
  ShareTripModalComponent,
  TripDetailModalComponent,
  MobileIFrameExportPdfAlertModal,
  CreateTripModalComponent,
  SetContactsModalComponent,
  ToggleFeaturesModalComponent,
  EventSpiderModalComponent,
  SetEventPageTagModalComponent,
  ToggleIsClientModalComponent,
  ShowPlacesCountModalComponent,
  EventCountModalComponent,
  EventSubscriptionTiersModalComponent,
  SetPlaceSourceModalComponent,
  AccountUsersModalComponent,
  EditTourTitleModalComponent,
  ShowMoreEventTimesModalComponent,
  NoContentComponent,
  ListComponent,
  ListItemComponent,
  ListColumnHeaderComponent,
  MultipleFieldsComponent,
  ActionsComponent,
  RowActionButtonsComponent,
  PageSpinnerComponent,
  SearchComponent,
  SpinnerComponent,
  NearbyPlacesComponent,
  PlaceMapSectionComponent,
  VisitorTripAddToTripMenuComponent,
  VisitorSquareCardComponent,
  VisitorLongCardComponent,
  VisitorModernBlockCardComponent,
  SideFloatComponent,
  SuccessWrapComponent,
  CardComponent,
  CardActionComponent,
  SocialLoginPopupComponent,
  FacebookLoginButtonComponent,
  GoogleLoginButtonComponent,
  FacebookPostComponent,
  GooglePlaceReviewsComponent,
  VisitorPlaceOpeningHoursComponent,
  SelectComponent,
  ImageComponent,
  ImageViewerComponent,
  UpcomingEventsComponent,
  NestedMenusComponent,
  NestedMenuItemComponent,
  EventFilterComponent,

  ShowInfoModalComponent,
  AddCityModalComponent,
  EditCityModalComponent,
  SearchGooglePlaceResultModalComponent,
  AssignTourModalComponent,
  PlaceDetailsModalComponent,
  EventDetailsModalComponent,
  PullGooglePlaceTypeModalComponent,

  OnlyIntegerInputDirective,
  OnlyFloatInputDirective,
  VisibilityHiddenDirective,
  EmptyRouterLinkDirective,
  DebounceEventDirective,
  ClickStopPropagationDirective,

  AddSpiderEvenetsModalComponent,
  SocialShareComponent,
  AddEventbriteEvenetsModalComponent,

  ImageSelectorComponent,
  ImageCropperWithPreviewComponent,
  ImageResizeComponent,

  AccordionEditorComponent,
  CustomDefaultPlaceCategoryAccordionComponent,
  
  HighlightPipe
];

const THIRD_PARTY_MODULES = [
  BrowserModule,
  HttpClientModule,
  FormsModule,
  ReactiveFormsModule,
  NgCommonModule,
  RouterModule,
  BrowserAnimationsModule,
  MatAutocompleteModule,
  MatInputModule,
  MatButtonModule,
  MatListModule,
  MatIconModule,
  MatSelectModule,
  MatTooltipModule,
  MatRadioModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatCheckboxModule,
  MatDialogModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatExpansionModule,
  MatSidenavModule,
  MatMenuModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatTabsModule,
  MatChipsModule,

  Md2DatepickerModule,
  ColorPickerModule,
  ImageCropperModule,
];

const MODAL_COMPONENTS = [
  ErrorHandlerModalComponent,
  CommonErrorHandlerModalComponent,
  ConfirmModalComponent,
  InputModalComponent,
  ExportPdfModalComponent,
  EditEventModalComponent,
  AIEventClassificationModalComponent,
  ResizeImageModalComponent,
  ShowImageModalComponent,
  EditPlaceModalComponent,
  EditPlaceImagesModalComponent,
  EditManuallyPlaceImagesModalComponent,
  EditPlaceCategoryModalComponent,
  PlaceCategorySelectorComponent,
  BulkAIDescriptionsModalComponent,
  UpgradeModalComponent,
  ShareTripModalComponent,
  TripDetailModalComponent,
  MobileIFrameExportPdfAlertModal,
  CreateTripModalComponent,
  SetContactsModalComponent,
  ToggleFeaturesModalComponent,
  EventSpiderModalComponent,
  SetEventPageTagModalComponent,
  ToggleIsClientModalComponent,
  ShowPlacesCountModalComponent,
  EventCountModalComponent,
  EventSubscriptionTiersModalComponent,
  SetPlaceSourceModalComponent,
  AccountUsersModalComponent,
  EditTourTitleModalComponent,
  ShowMoreEventTimesModalComponent,
  UnsavedWarningModalComponent,
  PlaceDetailsModalComponent,
  EventDetailsModalComponent,

  ShowInfoModalComponent,
  AddCityModalComponent,
  EditCityModalComponent,
  SearchGooglePlaceResultModalComponent,
  PullGooglePlaceTypeModalComponent,
  AssignTourModalComponent,

  AddSpiderEvenetsModalComponent,
  AddEventbriteEvenetsModalComponent,
  SetIgVersionModalComponent,
  TravelBuddySettingsModalComponent,
  TravelBuddyConversationsModalComponent,
  ShowCategoryLinkModalComponent,
  ShowPromptModalComponent,
  EventPullingStatusModalComponent,
];

@NgModule({
  imports: [...THIRD_PARTY_MODULES, NgbDropdownModule.forRoot(), AgmCoreModule.forRoot(), NgDragDropModule.forRoot()],
  declarations: [COMMON_COMPONENTS, ...MODAL_COMPONENTS],
  exports: [...COMMON_COMPONENTS, ...THIRD_PARTY_MODULES],
  entryComponents: MODAL_COMPONENTS,
})
export class CommonModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: CommonModule,
      providers: [
        UnsavedChangesGuard,
        ModalService,
        {
          provide: MD_DATE_FORMATS,
          useValue: {
            parse: {
              dateInput: null,
            },
            display: {
              dateInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
              monthYearLabel: {year: 'numeric', month: 'short'},
              dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
              monthYearA11yLabel: {year: 'numeric', month: 'long'},
            },
          },
        },
      ],
    };
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/common.module.ts